export const SourceEnum = Object.freeze({
    BOOKING: 0,
    LIST_BOOKING: 1
  });